var map = {
	"./blockchain-icon-1.png": 9733,
	"./blockchain-icon-2.png": 3963,
	"./blockchain-img.png": 1359,
	"./brain-check-times.png": 7492,
	"./brain-check-times.svg": 2394,
	"./brain-img.png": 3106,
	"./bubbles-big.png": 7005,
	"./bubbles-big.svg": 5875,
	"./bubbles.png": 8382,
	"./bubbles.svg": 3845,
	"./crpto-blockchain-icon-1.png": 9177,
	"./crypto-icon-1.png": 8229,
	"./crypto-icon-2.png": 1420,
	"./data-services.png": 8635,
	"./digital-marketing-icon.png": 1800,
	"./empty-hex.png": 9423,
	"./empty-hex.svg": 4027,
	"./facebook.png": 1902,
	"./facebook.svg": 1795,
	"./fill-hex.jpg": 3008,
	"./fill-hex.png": 139,
	"./fill-hex.svg": 8373,
	"./footer-logo.jpg": 4780,
	"./footer-logo.png": 7720,
	"./footer-logo.svg": 6803,
	"./hero-bg-img.jpg": 878,
	"./instagram.png": 2892,
	"./lines.png": 10,
	"./lines.svg": 5817,
	"./linkedin.png": 6497,
	"./linkedin.svg": 2340,
	"./logo.jpg": 3680,
	"./logo.png": 7877,
	"./logo.svg": 9014,
	"./mobile-app-2.png": 6879,
	"./mobile-app-icon-1.png": 9355,
	"./mobile-app-icon-3.png": 9168,
	"./news-img-1.png": 2632,
	"./news-img-2.png": 6639,
	"./news-img-3.png": 6237,
	"./plus-pattern.png": 7256,
	"./plus-pattern.svg": 4701,
	"./port-blockchain-2.webp": 4648,
	"./port-blockchain.webp": 7265,
	"./port-data-analytics-2.webp": 1454,
	"./port-data-analytics-3.jpg": 1096,
	"./port-data-analytics-4.webp": 5835,
	"./port-data-analytics-5.jpg": 24,
	"./port-data-analytics.webp": 6359,
	"./port-foundation-mixer.jpg": 7641,
	"./port-foundation-nft.jpg": 9003,
	"./port-gas-guzzlrs.jpg": 7079,
	"./port-half-leash-full.jpg": 9049,
	"./port-half-leash.jpg": 2578,
	"./port-happy-bear.jpg": 3148,
	"./port-mobile-app-2.jpg": 8073,
	"./port-mobile-app-3.webp": 5105,
	"./port-mobile-app-4.webp": 8651,
	"./port-mobile-app-5.webp": 5673,
	"./port-mobile-app-6.webp": 3952,
	"./port-mobile-app-7.webp": 5983,
	"./port-mobile-app-8.webp": 4449,
	"./port-mobile-app.png": 6619,
	"./port-websites-2.jpg": 549,
	"./port-websites-3.webp": 503,
	"./port-websites-4.png": 7542,
	"./port-websites-5.png": 1943,
	"./port-websites-6.webp": 9470,
	"./software-development-icon-1.png": 3797,
	"./software-development-icon-2.png": 1808,
	"./software-development-icon-3.png": 3634,
	"./twitter.png": 4789,
	"./twitter.svg": 9812,
	"./web-dev-icon-1.png": 2165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7550;